import React, { useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { ColorButton } from "../utils/ColorButton.js";
import Soploon from "../utils/images/soploon.png";
import auth from "../utils/Auth.js";
import Axios from "axios";
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { IconButton } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  image: {
    width: "70px"
  },
  error: {
    color: "red"
  }
}));

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Herramienta de estadística y gestión "}
      <Link color="inherit" href="https://si.isistan.unicen.edu.ar/soploon/#/">
        Soploon
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default function Login({ history }) {
  const classes = useStyles();
  const [error, setError] = useState(false);
  const [data, setData] = useState({
    email: "",
    password: ""
  });
  const [showPassword, setShowPassword] = useState(false);

  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": "*"
    }
  };

  const handleSubmit = e => {
    const params = new URLSearchParams();
    params.append("email", data.email);
    params.append("password", data.password);

    Axios.post(
      process.env.REACT_APP_BASE_URL + "/authentication",
      params,
      config
    ).then(response => {
      var credentials = { "email": data.email, "password": data.password }
      Axios.defaults.headers.common["Authorization"] = "Bearer " + response.data;
      auth.login(credentials, response.data);
      localStorage.setItem("auth", JSON.stringify(auth));
      history.push("/");
    })
      .catch(function (error) {
        setError(true);
      });
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("auth"));
    if (user != null && user.authenticated) {
      history.push("/");
    }
  }, [history]);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <img src={Soploon} alt="Soploon" className={classes.image} />
        <Typography component="h1" variant="h5">
          Iniciar sesión
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Correo electrónico"
            name="email"
            autoComplete="email"
            onChange={handleChange}
            autoFocus
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Contraseña"
            type={showPassword ? 'text' : 'password'}
            id="password"
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                  <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                  >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
              ),
          }}
          />
        </form>
        {error && (
          <Typography className={classes.error}>
            Usuario y/o contraseña incorrecta
          </Typography>
        )}
        <ColorButton
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          className={classes.submit}
        >
          Ingresar
        </ColorButton>
        <Link
          component="button"
          variant="body2"
          onClick={() => history.push("/signup")}
          className={classes.signUpLink}
        >
          ¿No tienes una cuenta? Regístrate
        </Link>
      </div>

      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}
